import React from "react";
import { Button, Form, Icon, Input, message, Modal } from "antd";
import { connect } from "react-redux";

import { Parse } from "parse";
//import { logIn } from '../Actions/user.actions';

const FormItem = Form.Item;

class ModalPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
    this.handleCancel = this.handleCancel.bind(this);
  }

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false
    });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue("newPassword")) {
      callback("Les mots de passe ne correspondent pas");
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };

  handleSubmit = e => {
    var ctx = this;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        var newPassword = values.newPassword;
        var oldPassword = values.oldPassword;
        var user = Parse.User.current();
        var username = user.get("username");

        Parse.User.logIn(username, oldPassword, {
          success: function(user) {
            user.setPassword(newPassword);
            user.save(null);
            message.success("Votre mot de passe a bien été modifié !");

            ctx.handleCancel();
          },
          error: function(error) {
            message.error("Votre mot de passe est erroné !");
          }
        });
      } else {
        message.error("échec");
      }
    });
  };

  /*  handleDisconnect = (e) => {
  this.setState({
    visible: false,
    disconnect: true
  });
}
*/
  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div style={{ marginTop: "5px" }}>
      <span
        style={{
          fontSize: "13px",
          fontWeight: "bold",
          color: "#0000FE",
          cursor: 'pointer'
        }}
          onClick={this.showModal}
        >
        <Icon type="lock" theme="filled" />
          {" "}
          Changer de mot de passe
        </span>
        <Modal
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={null}
        >
          Changer mon mot de passe
          <Form onSubmit={this.handleSubmit} className="login-form">
            <FormItem onChange={this.handleChange}>
              {getFieldDecorator("oldPassword", {
                rules: [
                  {
                    required: true,
                    message: "Indiquez votre ancien mot de passe"
                  }
                ]
              })(
                <Input
                  prefix={
                    <Icon type="unlock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  type="password"
                  placeholder="Votre ancien mot de passe"
                />
              )}
            </FormItem>
            <FormItem onChange={this.props.handleChange2}>
              {getFieldDecorator("newPassword", {
                rules: [
                  {
                    required: true,
                    message: "Indiquez votre nouveau mot de passe"
                  },
                  {
                    validator: this.validateToNextPassword
                  }
                ]
              })(
                <Input
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  type="password"
                  placeholder="Votre nouveau mot de passe"
                />
              )}
            </FormItem>
            <FormItem onChange={this.props.handleChange2}>
              {getFieldDecorator("newPassword1", {
                rules: [
                  {
                    required: true,
                    message:
                      "Saisissez votre nouveau mot de passe une deuxième fois"
                  },
                  {
                    validator: this.compareToFirstPassword
                  }
                ]
              })(
                <Input
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  type="password"
                  placeholder="Vérifiez votre mot de passe"
                />
              )}
            </FormItem>
            <Button
              style={{
                fontSize: "14px",
                color: "#fff",
                backgroundColor: "#0000FE",
                borderColor: "#0000FE"
              }}
              htmlType="submit"
            >
              Valider
            </Button>
          </Form>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;

const ModalPasswordForm = Form.create()(ModalPassword);

export default connect(
  mapStateToProps,
  null
)(ModalPasswordForm);
